import { trace } from 'owa-trace';
import type { IsSharedType, CollabSpaceData } from 'owa-calendar-types';

export const parseCollabSpace = (collabSpace: string | null): CollabSpaceData => {
    let shareLinkUrl: string = null;
    let enabled: boolean = null;
    let isShared: IsSharedType = null;

    if (collabSpace) {
        try {
            const parsedCollabSpace = JSON.parse(collabSpace);
            if (parsedCollabSpace) {
                const { location, metadata } = parsedCollabSpace;
                shareLinkUrl = location;
                if (metadata) {
                    enabled = metadata.state === 'Enabled' ? true : false;
                    isShared = metadata.isShared as IsSharedType;
                }
            }
        } catch (e) {
            trace.warn('Unable to parse collab space extended property: ' + collabSpace);
        }
    }
    return {
        shareLinkInfo: { url: shareLinkUrl?.length > 0 ? shareLinkUrl : null, linkId: null },
        enabled: shareLinkUrl?.length > 0 ? enabled : null,
        isShared: shareLinkUrl?.length > 0 ? isShared : null,
        changeKey: null,
        resourceId: null,
    };
};
